import React, { useState } from 'react';

import { FormInput } from '@/components/shared/Inputs';
import { Blurb } from '@/components/shared/Inputs/Blurb';
import { Label } from '@/components/shared/Inputs/Label';
import { SingleActionLayout } from '@/components/shared/SingleActionLayout/SingleActionLayout';
import { TeamSong } from '@/graphql';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { AddCustomSongDisplayProps } from '../AddCustomSong';
import styles from './SpotifyUrl.module.scss';

type FormSchema = {
	spotifyId?: string;
};

type Props = {
	teamSong: Partial<Pick<TeamSong, 'spotifyId'>>;
	onSubmit: (values: { spotifyId: TeamSong['spotifyId'] }) => void;
};

const signUpValidationSchema: Yup.SchemaOf<FormSchema> = Yup.object().shape({
	spotifyId: Yup.string()
		.optional()
		.matches(
			/^(?=https:\/\/).+(?=spotify).+\/track\//,
			'The URL must be valid and contain /track/',
		)
		.max(500, 'Can not be more than 500 characters'),
	// spotifyId: Yup.string().required('Please enter a valid url'),
});

export const SpotifyUrl: React.FC<Props> = ({ teamSong, onSubmit }) => {
	const { spotifyId } = teamSong;
	const [touched, setTouched] = useState(false);
	const initialValues: FormSchema = {
		spotifyId: spotifyId || '',
	};
	return (
		<Formik
			key="asaphSignUn"
			initialValues={initialValues}
			validationSchema={signUpValidationSchema}
			onSubmit={(values) => {
				onSubmit({
					spotifyId: values.spotifyId || null,
				});
			}}
		>
			{({ handleSubmit, handleChange, values, errors, isValid }) => (
				<SingleActionLayout
					actionLabel="Save Spotify URL"
					actionDisabled={!isValid || !touched}
					onActionClick={handleSubmit}
				>
					<form
						onSubmit={handleSubmit}
						id="asaphSignIn"
						className={styles['root']}
					>
						<Label>Song Spotify URL</Label>
						<FormInput
							placeholder="Enter url"
							name="spotifyId"
							id="spotifyId"
							autoComplete="off"
							value={values.spotifyId}
							onChange={(e) => {
								setTouched(true);
								handleChange(e);
							}}
							error={!!errors.spotifyId}
						/>
						{errors.spotifyId && (
							<Blurb isError>{errors.spotifyId}</Blurb>
						)}
						<Blurb>
							To copy song URL, view your song on Spotify, then go
							to ••• &gt; Share &gt; Copy link. The URL must
							contain /track/.
						</Blurb>
					</form>
				</SingleActionLayout>
			)}
		</Formik>
	);
};
